<template>
    <div class="w-full py-2 rounded-xl border-blue-dark border-2 flex flex-col sm:flex-row justify-around items-center">
        <div class="w-full py-2">
            <p class=" text-gray-500 font-bold">{{ labelLeft }}</p>
            <p class="text-blue-dark font-bold">{{actionLeft}}</p>
        </div>
        <span class="block w-3/4 h-px sm:w-1 sm:h-16 bg-blue-dark"></span>
        <div class="w-full py-2">
            <p class=" text-gray-500 font-bold">{{ labelRight }}</p>
            <p :class="[status, 'font-bold']">{{actionRight}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['labelLeft', 'labelRight', 'actionLeft', 'actionRight', 'status'],
    components: {}
}
</script>